// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.problemCell{
    position: relative;
display: flex;
justify-content: center;
align-items: center;
height: 100%;
    /* border-left: 1px solid rgb(59, 59, 59); */
    /* border-bottom: 1px solid rgb(59, 59, 59); */
    
    color: var(--txt-color);
    font-size: var(--font-size-xSmall);
}
.problemCell img{
  /* background-color: red; */
  position: relative;
  /* animation: alertAnimation 0.5s infinite alternate; */
}
.problemCellWhite{
  position: relative;
display: flex;
justify-content: center;
align-items: center;
height: 100%;
  /* border-left: 1px solid rgb(59, 59, 59); */
  /* border-bottom: 1px solid rgb(59, 59, 59); */
  color: white;
  color: #003757;
}
.problemCellWhite img{
/* background-color: red; */
position: relative;
/* animation: alertAnimation 0.5s infinite alternate; */
}
@keyframes alertAnimation {
  0% {
    opacity: 1;
    transform: scale(0.8);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(0.8);
  }
}

.txtProblemCell{
    text-align: center;
position: relative;
/* width: 100%; */
/* height: auto; */
word-break: break-all;
/* margin: 0 0 1em 1em; */
display: flex;
font-size: var(--font-size-xSmall);
    letter-spacing: 0.5px;
justify-content: center;
margin: 2%;
}

.sphere {
    width: 15px;
    height: 15px;
    
    border-radius: 50%;
    position: relative;
    overflow: hidden;
  }
  .s1{
    /* background: radial-gradient(circle, lime 0%, rgb(45, 208, 45) 35%, rgb(1, 90, 1) 100%); */
    
    filter: brightness(120%);
    border-radius: 100%;
    width: 20%;
    animation: alertAnimation 1s infinite alternate;
    /* box-shadow: 0 0 5px lime; */
  }
  .s2{
/* background: radial-gradient(circle, rgb(255, 255, 88) 0%, yellow 35%, rgb(154, 154, 4) 100%); */
filter: brightness(120%);
    border-radius: 5%;
width: 25%;
animation: alertAnimation 0.8s infinite alternate;
  }
  .s3{
/* background: radial-gradient(circle, rgb(255, 200, 80) 0%, orange 35%, rgb(176, 114, 0) 100%); */
filter: brightness(120%);
    border-radius: 5%;
/* box-shadow: 0 0 5px rgb(244, 179, 38); */
animation: alertAnimation 0.6s infinite alternate;
width: 35%;
  }
  .s4{
    /* background: radial-gradient(circle, rgb(255, 103, 80) 0%, red 35%, rgb(176, 0, 0) 100%); */
    filter: brightness(120%);
    border-radius: 100%;
    animation: alertAnimation 0.4s infinite alternate;
    /* box-shadow: 0 0 5px rgb(255, 103, 80); */
    width: 40%;
  }
  .s5{
    /* background: radial-gradient(circle, rgb(255, 103, 80) 0%, red 35%, rgb(176, 0, 0) 100%); */
    filter: brightness(120%);
    border-radius: 100%;
    animation: alertAnimation 0.4s infinite alternate;
    /* box-shadow: 0 0 5px rgb(255, 103, 80); */
    width: 50%;
  }
  .txtSeverity{
    font-size: x-small;
    margin-left: 5%;
  }
  /* .rowProblem{
    position: relative;
    display: flex;
    overflow: hidden;
    background-size: 400%;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: auto;
    border-bottom: 1px solid #80808042;
    border-top: 1px solid #80808042;
    
}
  .rowProblem:hover{
background-color: rgb(127, 127, 127);
cursor: pointer;
  } */
  .rowProblem {
    position: relative;
    display: flex;
    overflow: hidden;
    height: 3rem;
    /* background: #5d5c69; */
    background-color: var(--white-color);
    background-size: 400%;
    color: #fff;
    border-bottom: 1px solid #80808038;
    width: 100%;
  }
  .rowProblem:hover{
    cursor: pointer;
    background-color: var(--hover-color) !important;
  }
  /* .rowProblem:hover::before {
    transform: scaleX(1);
    cursor: pointer;
  } */
  
  /* .rowProblem-hover {
    position: relative;
    z-index: 1;
  } */
  .rowProblem::before {
    /* content: '';
    position: absolute;
    top: 0;
    left: 0;
    transform: scaleX(0);
    transform-origin: 0 50%;
    width: 100%;
    height: inherit;
    border-radius: inherit; */
    /* background: linear-gradient(
      82.3deg,
      rgba(252, 169, 169, 0.623) 10.8%,
      rgba(212, 142, 142, 0.63) 94.3%
    ); */
    /* background: #a6a5b850;
    transition: all 0.275s; */
  }
  .PROBLEM{
    background-color: #964f4f;
  }
  .RESOLVED{
    background-color: #56815f;
  }
  .iconAgencyProblem{
width: 80%;
  }
  .pointProblemCell{
   width: 15px;
   height: 15px;
    border-radius: 50%;
    background-color: rgba(128, 128, 128, 0.219);
    border: solid 1px gray;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pointProblemCell .centerPoint{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--green);
  }





  .icon-user-contaner {
  position: relative;
  display: inline-block;
}



.tooltip-text {
  visibility: hidden;
  background-color: rgba(247, 247, 247, 0.918);
  color: var(--third-color);
  border: 1px solid var(--txt-color) ;
  text-align: center;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 0%;
  left: 100%;
  /* transform: translateX(-50%); */
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
}

.icon-user-contaner:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/RowProblem.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,YAAY;IACR,4CAA4C;IAC5C,8CAA8C;;IAE9C,uBAAuB;IACvB,kCAAkC;AACtC;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,uDAAuD;AACzD;AACA;EACE,kBAAkB;AACpB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,YAAY;EACV,4CAA4C;EAC5C,8CAA8C;EAC9C,YAAY;EACZ,cAAc;AAChB;AACA;AACA,2BAA2B;AAC3B,kBAAkB;AAClB,uDAAuD;AACvD;AACA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;IACI,kBAAkB;AACtB,kBAAkB;AAClB,iBAAiB;AACjB,kBAAkB;AAClB,qBAAqB;AACrB,yBAAyB;AACzB,aAAa;AACb,kCAAkC;IAC9B,qBAAqB;AACzB,uBAAuB;AACvB,UAAU;AACV;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,4FAA4F;;IAE5F,wBAAwB;IACxB,mBAAmB;IACnB,UAAU;IACV,+CAA+C;IAC/C,8BAA8B;EAChC;EACA;AACF,kGAAkG;AAClG,wBAAwB;IACpB,iBAAiB;AACrB,UAAU;AACV,iDAAiD;EAC/C;EACA;AACF,kGAAkG;AAClG,wBAAwB;IACpB,iBAAiB;AACrB,2CAA2C;AAC3C,iDAAiD;AACjD,UAAU;EACR;EACA;IACE,6FAA6F;IAC7F,wBAAwB;IACxB,mBAAmB;IACnB,iDAAiD;IACjD,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,6FAA6F;IAC7F,wBAAwB;IACxB,mBAAmB;IACnB,iDAAiD;IACjD,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;;;;;;;;;;;;;;;;KAgBG;EACH;IACE,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,oCAAoC;IACpC,qBAAqB;IACrB,WAAW;IACX,kCAAkC;IAClC,WAAW;EACb;EACA;IACE,eAAe;IACf,+CAA+C;EACjD;EACA;;;KAGG;;EAEH;;;KAGG;EACH;IACE;;;;;;;;6BAQyB;IACzB;;;;QAII;IACJ;6BACyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;AACF,UAAU;EACR;EACA;GACC,WAAW;GACX,YAAY;IACX,kBAAkB;IAClB,4CAA4C;IAC5C,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;EAChC;;;;;;EAMA;EACA,kBAAkB;EAClB,qBAAqB;AACvB;;;;AAIA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,iCAAiC;EACjC,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":[".problemCell{\r\n    position: relative;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nheight: 100%;\r\n    /* border-left: 1px solid rgb(59, 59, 59); */\r\n    /* border-bottom: 1px solid rgb(59, 59, 59); */\r\n    \r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-xSmall);\r\n}\r\n.problemCell img{\r\n  /* background-color: red; */\r\n  position: relative;\r\n  /* animation: alertAnimation 0.5s infinite alternate; */\r\n}\r\n.problemCellWhite{\r\n  position: relative;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nheight: 100%;\r\n  /* border-left: 1px solid rgb(59, 59, 59); */\r\n  /* border-bottom: 1px solid rgb(59, 59, 59); */\r\n  color: white;\r\n  color: #003757;\r\n}\r\n.problemCellWhite img{\r\n/* background-color: red; */\r\nposition: relative;\r\n/* animation: alertAnimation 0.5s infinite alternate; */\r\n}\r\n@keyframes alertAnimation {\r\n  0% {\r\n    opacity: 1;\r\n    transform: scale(0.8);\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n    transform: scale(1.1);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(0.8);\r\n  }\r\n}\r\n\r\n.txtProblemCell{\r\n    text-align: center;\r\nposition: relative;\r\n/* width: 100%; */\r\n/* height: auto; */\r\nword-break: break-all;\r\n/* margin: 0 0 1em 1em; */\r\ndisplay: flex;\r\nfont-size: var(--font-size-xSmall);\r\n    letter-spacing: 0.5px;\r\njustify-content: center;\r\nmargin: 2%;\r\n}\r\n\r\n.sphere {\r\n    width: 15px;\r\n    height: 15px;\r\n    \r\n    border-radius: 50%;\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n  .s1{\r\n    /* background: radial-gradient(circle, lime 0%, rgb(45, 208, 45) 35%, rgb(1, 90, 1) 100%); */\r\n    \r\n    filter: brightness(120%);\r\n    border-radius: 100%;\r\n    width: 20%;\r\n    animation: alertAnimation 1s infinite alternate;\r\n    /* box-shadow: 0 0 5px lime; */\r\n  }\r\n  .s2{\r\n/* background: radial-gradient(circle, rgb(255, 255, 88) 0%, yellow 35%, rgb(154, 154, 4) 100%); */\r\nfilter: brightness(120%);\r\n    border-radius: 5%;\r\nwidth: 25%;\r\nanimation: alertAnimation 0.8s infinite alternate;\r\n  }\r\n  .s3{\r\n/* background: radial-gradient(circle, rgb(255, 200, 80) 0%, orange 35%, rgb(176, 114, 0) 100%); */\r\nfilter: brightness(120%);\r\n    border-radius: 5%;\r\n/* box-shadow: 0 0 5px rgb(244, 179, 38); */\r\nanimation: alertAnimation 0.6s infinite alternate;\r\nwidth: 35%;\r\n  }\r\n  .s4{\r\n    /* background: radial-gradient(circle, rgb(255, 103, 80) 0%, red 35%, rgb(176, 0, 0) 100%); */\r\n    filter: brightness(120%);\r\n    border-radius: 100%;\r\n    animation: alertAnimation 0.4s infinite alternate;\r\n    /* box-shadow: 0 0 5px rgb(255, 103, 80); */\r\n    width: 40%;\r\n  }\r\n  .s5{\r\n    /* background: radial-gradient(circle, rgb(255, 103, 80) 0%, red 35%, rgb(176, 0, 0) 100%); */\r\n    filter: brightness(120%);\r\n    border-radius: 100%;\r\n    animation: alertAnimation 0.4s infinite alternate;\r\n    /* box-shadow: 0 0 5px rgb(255, 103, 80); */\r\n    width: 50%;\r\n  }\r\n  .txtSeverity{\r\n    font-size: x-small;\r\n    margin-left: 5%;\r\n  }\r\n  /* .rowProblem{\r\n    position: relative;\r\n    display: flex;\r\n    overflow: hidden;\r\n    background-size: 400%;\r\n    width: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: auto;\r\n    border-bottom: 1px solid #80808042;\r\n    border-top: 1px solid #80808042;\r\n    \r\n}\r\n  .rowProblem:hover{\r\nbackground-color: rgb(127, 127, 127);\r\ncursor: pointer;\r\n  } */\r\n  .rowProblem {\r\n    position: relative;\r\n    display: flex;\r\n    overflow: hidden;\r\n    height: 3rem;\r\n    /* background: #5d5c69; */\r\n    background-color: var(--white-color);\r\n    background-size: 400%;\r\n    color: #fff;\r\n    border-bottom: 1px solid #80808038;\r\n    width: 100%;\r\n  }\r\n  .rowProblem:hover{\r\n    cursor: pointer;\r\n    background-color: var(--hover-color) !important;\r\n  }\r\n  /* .rowProblem:hover::before {\r\n    transform: scaleX(1);\r\n    cursor: pointer;\r\n  } */\r\n  \r\n  /* .rowProblem-hover {\r\n    position: relative;\r\n    z-index: 1;\r\n  } */\r\n  .rowProblem::before {\r\n    /* content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    transform: scaleX(0);\r\n    transform-origin: 0 50%;\r\n    width: 100%;\r\n    height: inherit;\r\n    border-radius: inherit; */\r\n    /* background: linear-gradient(\r\n      82.3deg,\r\n      rgba(252, 169, 169, 0.623) 10.8%,\r\n      rgba(212, 142, 142, 0.63) 94.3%\r\n    ); */\r\n    /* background: #a6a5b850;\r\n    transition: all 0.275s; */\r\n  }\r\n  .PROBLEM{\r\n    background-color: #964f4f;\r\n  }\r\n  .RESOLVED{\r\n    background-color: #56815f;\r\n  }\r\n  .iconAgencyProblem{\r\nwidth: 80%;\r\n  }\r\n  .pointProblemCell{\r\n   width: 15px;\r\n   height: 15px;\r\n    border-radius: 50%;\r\n    background-color: rgba(128, 128, 128, 0.219);\r\n    border: solid 1px gray;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .pointProblemCell .centerPoint{\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    background-color: var(--green);\r\n  }\r\n\r\n\r\n\r\n\r\n\r\n  .icon-user-contaner {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n\r\n\r\n.tooltip-text {\r\n  visibility: hidden;\r\n  background-color: rgba(247, 247, 247, 0.918);\r\n  color: var(--third-color);\r\n  border: 1px solid var(--txt-color) ;\r\n  text-align: center;\r\n  border-radius: 4px;\r\n  padding: 5px;\r\n  position: absolute;\r\n  z-index: 1;\r\n  bottom: 0%;\r\n  left: 100%;\r\n  /* transform: translateX(-50%); */\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  transition: opacity 0.3s;\r\n}\r\n\r\n.icon-user-contaner:hover .tooltip-text {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
